import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AddIcon from "@mui/icons-material/Add";
import {
  GENERAL_NAV_ELEMENTS,
  NEW_ITEM_NAV_ELEMENTS,
  NEW_LIST_MAIN_NAV_ELEMENTS,
} from "constant/navigation";
import styled from "styled-components";
import { Logout } from "@mui/icons-material";
import LogoutNav from "../LogoutNav/LogoutNav";
import NavigationGroup from "./NavigationGroup";

const LogoutNavDiv = styled.div`
  margin-left: 1rem;
  margin-top: 1rem;
`;

const drawer = (
  <div>
    <Toolbar />
    <Divider />
    <List>
      <ListItem key={"home"} disablePadding>
        <NavLink to="/">
          <ListItemButton>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Start" />
          </ListItemButton>
        </NavLink>
      </ListItem>
      <Divider />
      {NEW_ITEM_NAV_ELEMENTS.map(({ title, path }) => (
        <ListItem key={title} disablePadding>
          <NavLink to={path}>
            <ListItemButton>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              <ListItemText primary={title} />
            </ListItemButton>
          </NavLink>
        </ListItem>
      ))}
    </List>
    <Divider />
    <NavigationGroup
      navElements={NEW_LIST_MAIN_NAV_ELEMENTS}
      dividerAdd={true}
    />
    <NavigationGroup navElements={GENERAL_NAV_ELEMENTS} dividerAdd={true} />
    <LogoutNavDiv>
      <LogoutNav />
    </LogoutNavDiv>
  </div>
);

const handleDrawerToggle = () => {};
const drawerWidth = 240;

const MainNavigation = () => {
  return (
    <>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={window.document.body}
          variant="temporary"
          open={true}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
};

export default MainNavigation;
